<script setup lang="ts">
import ProductCatalog from "~/components/products/ProductCatalog.vue";
</script>

<template>
  <ProductCatalog />
</template>
